import { useEffect } from 'react';
import { useState } from 'react';
import { getPlans } from '../../api/API';

export default function usePlans() {
	const [plans, setPlans] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchPlans = async () => {
			try {
				const data = await getPlans();
				setPlans(data);
			} catch (err) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchPlans();
	}, []);

	return { plans, loading, error };
}
